module.exports = __webpack_public_path__ + "static/media/end-of-subscription.3843a9b0.svg";